import { associateMusic } from './associate-music';
import { createMusic } from './create-music';
import { getAssociatedMusic } from './get-associated-music';
import { getMusics } from './get-musics';

export const musicService = {
  getMusics,
  createMusic,
  associateMusic,
  getAssociatedMusic,
};
